






import {Component, Vue} from "vue-property-decorator";

import {Store} from '@/enums/Store';

import {EventInterface} from "@/types/Event";

import {Event} from "@/util/Event";

import {namespace} from 'vuex-class';

import EventItem from "@/components/Event/EventItem.vue";

const EVENT = namespace(Store.EVENT);
const APP = namespace(Store.APP);

@Component({
  components: {EventItem}
})
export default class EventSelection extends Vue {
  @EVENT.Getter('eventObjects') events?: Event[];
  @EVENT.Mutation('SET_EVENTS') setEvents!: (events: EventInterface[]) => void;

  @APP.State('promoterId') promoterId!: number;
  @APP.State('storeId') storeId!: number;
  @APP.State('showInactiveEvents') showInactiveEvents!: string;
  @APP.Mutation('ADD_ERROR') addError!: (error: Error) => void;

  created(): void {
    this.fetchEvents();
  }

  async fetchEvents() {
    try {
      const events = await this.$api.get<EventInterface[]>(`/events/promoter/${this.promoterId}/${this.storeId}?showInactiveEvents=${this.showInactiveEvents}`);
      if (this.$api.deserialize) {
        this.setEvents(events);
      }
    } catch (e) {
      this.addError(e);
    }
  }
}
